import React from "react";
import headSectionImage from "./@Images/headSectionImage.svg";
import {HeadSectionComponent} from "../../Parts/Sections";
import JoinQyvoPageRegisterForm from "@Pages/JoinQyvo/RegisterForm";
import {PageContainerComponent} from "@Components/Sections";


export const JoinQyvoPage:React.FC = () => {

    return (
        <PageContainerComponent pageType={'join-qyvo-page'}>

            <HeadSectionComponent
                pageName={'join-qyvo'}
                sectionHeaderText={'Join Qyvo Today'}
                sectionSubText={'Start getting automatic refunds from your inbox. Set up your account in minutes and let our AI find money you\'re owed.'}
                sectionImage={headSectionImage}
            />

            <JoinQyvoPageRegisterForm />

        </PageContainerComponent>
    );

};


export default JoinQyvoPage;
